module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic06.84f2aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic06.png
// module id = 524
// module chunks = 1